export class ObservationType {
  id: number;
  isArchived: boolean;
  modifiedOn: string;
  name: string;
  typeName: string;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/models/observation-type.ts